var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-view',{on:{"announce":_vm.announce}}),_c('p',{staticClass:"sr-only",attrs:{"role":"status"}},[_vm._v(_vm._s(_vm.statusMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }